
import { defineComponent } from 'vue'

export default defineComponent({
    props: {
        statusId: {
            type: Number,
            default: null
        },
        statusName: {
            type: String,
            default: null
        }
    }
})
